const routes = {
  airlineCreate: "/airlines/create",
  airlineUpdate: "/airlines/:id/update",
  airlineDelete: "/airlines/:id/delete",
  airlineDetail: "/airlines/:id",
  airlineList: "/airlines",
}

export default routes
